/**
 * Returns a psuedo-random integer between `min` and `max`, inclusive.
 *
 * @param { number } min
 * @param { number } max
 *
 * @returns { number }
 */
// eslint-disable-next-line snakecasejs/snakecasejs
export const randIntBetween = (min, max) => Math.floor(Math.random() * (max - min + 1) + min);
